module.exports = __webpack_public_path__ + "img/paypal.9599c1a7.svg";